import { POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES } from '../../../../../constants/infrastructure';
import { EInsideTAInfrastructureType } from '../../../../../types/map';

export function isRouteForTypeAvailable(type: string) {
  return !POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES.includes(type as EInsideTAInfrastructureType);
}
